import { render, staticRenderFns } from "./SessionsDropdown.vue?vue&type=template&id=6bc6efdc&scoped=true&"
import script from "./SessionsDropdown.vue?vue&type=script&lang=ts&"
export * from "./SessionsDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./SessionsDropdown.vue?vue&type=style&index=0&id=6bc6efdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc6efdc",
  null
  
)

export default component.exports